import React from 'react'
import { Form, Modal, Input, Spin } from 'antd'
import Cards from 'react-credit-cards-2'
import 'react-credit-cards-2/dist/lib/styles-compiled.css'
import './styles.scss'
import Visa_Master_Discover_Amex from '../../assets/logo/Visa_Master_Discover_Amex.png'

export default Form.create()(
    ({
        visible,
        title,
        loading,
        on_cancel,
        on_save,
        name,
        number,
        expiry,
        cvc,
        focused,
        callback,
        on_focus,
        on_change,
        form,
    }) => {
        const { getFieldDecorator } = form
        return (
            <Modal
                className="payment-form"
                visible={visible}
                title="Billing Information"
                onCancel={on_cancel}
                onOk={on_save}
                closable={false}
                cancelText={'Cancel'}
                okText={'Save and Continue'}>
                <Spin spinning={loading}>
                    <h1>
                        {title
                            ? title
                            : 'In order to continue transfers, please enter your billing details'}
                    </h1>
                    <div>
                        <img
                            className={'cards-list'}
                            src={Visa_Master_Discover_Amex}
                            alt="Visa Master Discover Amex"
                        />

                        <Cards
                            number={number}
                            name={name}
                            expiry={expiry || '##/##'}
                            cvc={cvc}
                            focused={focused}
                            callback={callback}
                        />

                        <Form layout="vertical">
                            <div className="foot-content">
                                <Form.Item
                                    label="Card Number"
                                    className={'user-input'}>
                                    {getFieldDecorator('number', {
                                        rules: [
                                            {
                                                required: true,
                                                message:
                                                    'Please input correct card number',
                                            },
                                        ],
                                    })(
                                        <Input
                                            type="tel"
                                            name="number"
                                            placeholder="Card Number"
                                            onKeyUp={e => on_change(e.target)}
                                            onFocus={e => on_focus(e.target)}
                                        />
                                    )}
                                </Form.Item>

                                <Form.Item
                                    label="Name"
                                    className={'user-input'}>
                                    {getFieldDecorator('name', {
                                        rules: [
                                            {
                                                required: true,
                                                message:
                                                    'Please input your name',
                                            },
                                        ],
                                    })(
                                        <Input
                                            type="text"
                                            name="name"
                                            placeholder="Name"
                                            onKeyUp={e => on_change(e.target)}
                                            onFocus={e => on_focus(e.target)}
                                        />
                                    )}
                                </Form.Item>
                            </div>

                            <div className="foot-content">
                                <Form.Item
                                    label="Exp Date (mm/yy)"
                                    className={'user-input'}>
                                    {getFieldDecorator('expiry', {
                                        rules: [
                                            {
                                                required: true,
                                                message:
                                                    'Please input valid expiry date',
                                            },
                                        ],
                                    })(
                                        <Input
                                            type="tel"
                                            name="expiry"
                                            placeholder="Valid Thru"
                                            onKeyUp={e => on_change(e.target)}
                                            onFocus={e => on_focus(e.target)}
                                        />
                                    )}
                                </Form.Item>

                                <Form.Item label="CVC" className={'user-input'}>
                                    {getFieldDecorator('cvc', {
                                        rules: [
                                            {
                                                required: true,
                                                message:
                                                    'Please input valid cvc',
                                            },
                                        ],
                                    })(
                                        <Input
                                            type="tel"
                                            name="cvc"
                                            placeholder="CVC"
                                            onKeyUp={e => on_change(e.target)}
                                            onFocus={e => on_focus(e.target)}
                                        />
                                    )}
                                </Form.Item>
                            </div>
                        </Form>
                    </div>
                </Spin>
            </Modal>
        )
    }
)
